<template>
    <div class="exam-result-page p-3">
        <a-table
                :customRow="handleSelectRow"
                :data-source="data"
                :pagination="{ pageSize: pageSize, current: currentPage }"
                :scroll="{ y: 580, x: 0 }"
                @change="handleChangeTable"
                :loading="isLoading"
                :locale="{
                    emptyText: $t(`exam_student_result.label.no_data`)
                }"
        >
            <a-table-column
                :align="col.align"
                v-for="(col, index) in columns" :key="index"
                :title="$t(col.title)"
                :data-index="col.dataIndex"
                :custom-render="col.customRender"
                :sorter="col.sorter"
            />
        </a-table>
    </div>
</template>

<script>

import moment, {now} from "moment";
import {mapGetters} from "vuex";
import router       from "@/router";
import Cookies      from "js-cookie";

export default {
    components: {},
    data() {
        return {
            idExam: null,
            columns: [
                {
                    title: 'paperslist.label.stt',
                    align: "center",
                    width: 60,
                    customRender: (_, __, index) => {
                        return (this.currentPage - 1) * this.pageSize + index + 1;
                    }
                },
                {
                    title: "exam_student_result.label.nameExam",
                    dataIndex: 'exam_name'
                },
                {
                    title: "exam_student_result.label.student_name",
                    dataIndex: 'student_name',
                    align: "center",
                    width: 130
                },
                {
                    title: "exam_student_result.label.grade",
                    dataIndex: 'grade',
                    align: "center",
                    customRender: data => data === -1 ? this.$t("exam_student_result.label.no_grade") : data,
                    width: 80
                },
                {
                    title: "exam_student_result.label.total_score",
                    dataIndex: 'total_of_score',
                    align: "center",
                    sorter: (a, b) => a.total_of_score - b.total_of_score,
                    width: 105
                },
                {
                    title: "exam_student_result.label.total_mark",
                    dataIndex: 'total_of_mark',
                    align: "center",
                    sorter: (a, b) => a.total_of_mark - b.total_of_mark,
                    width: 105,
                    customRender: (data, record, index) => {
                        let arrAnswer = record.answer.filter((x)=>{
                            if((x.type === 'Speaking' || x.type === 'Writing') && x.answer !== 'noAnswer'){
                                return x;
                            }
                        });
                        // console.log(arrAnswer.length);
                        return  record.status === '1' && arrAnswer.length > 0 ? <span style="color: red;">Đợi giáo viên chấm bài</span> : record.total_of_mark;
                    },
                },
                {
                    title: "exam_student_result.label.total_question",
                    dataIndex: 'count_question',
                    align: "center",
                    width: 120
                },
                {
                    title: "exam_student_result.label.number_right_answer",
                    dataIndex: 'answer_correct',
                    align: "center",
                    width: 130
                },
                {
                    title: "exam_student_result.label.date_play",
                    dataIndex: 'update_at',
                    align: "center",
                    width: 120,
                    customRender: (data, record) => this.get_date_play(data, record),
                },
                {
                    title: "exam_student_result.label.time",
                    dataIndex: 'duration',
                    align: "center",
                    customRender: (data, record) => this.secondsToHms(data, record),
                    width: 120
                },
                {
                    title: "",
                    dataIndex: '',
                    align: "center",
                    customRender: (data, record, index) => {
                        return <b-icon onClick={e => this.toTryExam(record)} class="h4" style="cursor: pointer;" icon="eye-fill" variant="info"></b-icon>;
                        },
                    width: 50
                }
            ],
            data: [],
            isLoading: false,
            pageSize: 50,
            currentPage: 1
        };
    },
    computed: {
        ...mapGetters({
            listResultExam: "student/listResultExam"
        })
    },
    async created() {
        Cookies.remove("idResultExam");
        this.isLoading = true;
        this.$store.dispatch("student/getListResultExam", {idExam: Cookies.get("idExam")})
            .finally(() => {
                this.data = this.listResultExam.data;
                this.isLoading = false;
            });
    },
    methods: {
        toTryExam(record){
            Cookies.set("idResultExam", record.id);
            Cookies.set("idExam", record.exam_id);
            Cookies.set("typeExam", "result");
            router.push(`/student/exam/try-exam?${record.exam_id}&${record.exam_name.replace(/ /g, "-")}`);
        },
        handleSelectRow(record) {
            // return {
            //     on: {
            //         dblclick: () => {
            //             Cookies.set("idResultExam", record.id);
            //             Cookies.set("idExam", record.exam_id);
            //             Cookies.set("typeExam", "result");
			// 									router.push(`/student/exam/try-exam?${record.exam_id}&${record.exam_name.replace(/ /g, "-")}`)
            //         }
            //     }
            // };
        },
        get_date_play(d, record) {
            if(record && record.updated_at){
                return moment(record.updated_at).format("DD/MM/YYYY");
            }else {
                return moment(now()).format("DD/MM/YYYY")
            }
        },
        secondsToHms(d, record) {
            d = Number(d);
            let m = Math.floor(d / 60);
            let s = Math.floor(d % 3600 % 60);
            let mDisplay = m >= 10 ? m : "0"+m;
            let sDisplay = s >= 10 ? s : "0"+s;
            return this.timeOut = mDisplay +":"+ sDisplay + " / " + record.time_do_exam + ":00";
        },
        handleChangeTable(pagination, filters, sorter) {
            this.currentPage = pagination.current;
            this.pageSize = pagination.pageSize;
        }
    }
};

</script>
<style>
@import "../../assets/scss/ExamResultPage.scss";
</style>
